import React, { forwardRef } from 'react';

import { AttrsHelper } from '../../../sb-helpers/attrs-helper';

export type StackableRowItemProps = {
  /**
   * Which of the row's three places this takes. `main` is the one that grows into whatever the
   * other two leave, and the one that takes the whole row when the row stacks.
   *
   * **A place, not an item.** Leave one out and its track collapses; put several controls in one
   * item to fill it. Repeating an `area` lands both in the same cell.
   */
  area: 'leading' | 'main' | 'trailing';
  children?: React.ReactNode;
  name?: string;
};

export const StackableRowItem = forwardRef<
  HTMLDivElement,
  StackableRowItemProps
>(({ area, children, name }, ref) => (
  <div
    className={AttrsHelper.formatClassname(`stackable-row-${area}`)}
    data-test={name}
    ref={ref}
  >
    {children}
  </div>
));
